import numeral from 'numeral'

export default {
  props: {
    service: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    productReference() {
      return this.service?.product?.service_reference
    },

    accountName() {
      return this.service?.account?.name || '--'
    },

    businessName() {
      return this.service?.location?.business_name || '--'
    },

    customerReference() {
      return this.service?.customer_reference || '--'
    },

    serviceSpeed() {
      if (!this.service?.plan?.speed) {
        return
      }
      return `${this.service.plan.speed} Mbps Internet`
    },

    status() {
      return this.service?.status || '--'
    },

    address() {
      return this.service?.location?.premise?.address || '--'
    },

    mrc() {
      const vl = this.service?.total_price

      if (!vl) {
        return '--'
      }
      return numeral(vl).format('$0,0')
    },

    installFee() {
      const vl = this.service?.install_charge

      if (!vl) {
        return '--'
      }
      return numeral(vl).format('$0,0')
    },

    contractEnd() {
      return this.service?.active_contract?.contract_end || '--'
    },

    contractLength() {
      if (!this.service?.plan?.contract_length) {
        return '--'
      }

      return `${this.service.plan.contract_length} months`
    },

    ipAddressType() {
      return this.service?.handoff?.ip_address_type || '--'
    },

    ipAddress() {
      return this.service?.handoff?.ip_address || '--'
    },

    subnetMask() {
      return this.service?.handoff?.subnet_mask || '--'
    },

    defaultGateway() {
      return this.service?.handoff?.default_gateway || '--'
    },

    trunkPortVlan() {
      return this.service?.handoff?.service_delivery_port_vlan || '--'
    },

    portSpeedDuplex() {
      return this.service.handoff?.service_delivery_port_speed || '--'
    },

    portMedium() {
      return this.service?.handoff?.service_delivery_port_medium || '--'
    },

    serviceDeliveryPort() {
      //TODO if the text in here is numeric prepend with 'Port ' otherwise print the text
      return 'Port ' + this.service?.handoff?.service_delivery_port || '--'
    },

    zEnd() {
      return (
        '' +
          this.service.handoff?.delivered_to_type +
          this.service.handoff?.delivered_to_id || '--'
      )
    },

    zEndVlan() {
      return this.service?.handoff?.delivered_to_vlan || '--'
    },

    dataCentre() {
      const siteCode = this.service?.location?.premise?.primary_upstream
        ?.site_code
      const siteLocation = this.service?.location?.premise?.primary_upstream
        ?.location
      if (!siteCode || !siteLocation) {
        return '--'
      }

      return `[${siteCode}] - ${siteLocation}`
    },

    serviceDeliveryPortMedium() {
      const opt = {
        COPPER: 'Copper [Default]',
        SINGLE_MODE_FIBER: 'Single Mode Fiber (SMOF)',
        MULTI_MODE_FIBER: 'Multi Mode Fiber (MMOF)',
        VIRTUAL: 'Virtual'
      }
      return opt[this.service.handoff?.service_delivery_port_medium] || '--'
    },

    zendPortReference() {
      return this.service?.handoff?.x_connect_z_end_reference || '--'
    }
  }
}
